"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DetailPage = void 0;
const react_1 = __importDefault(require("react"));
const styles_1 = require("./styles");
const DetailPage = (props) => {
    const { backgroundColor, children } = props;
    return (react_1.default.createElement(styles_1.DetailPageContainer, { backgroundColor: backgroundColor },
        react_1.default.createElement("div", null,
            react_1.default.createElement("div", null, "DetailPage"),
            children)));
};
exports.DetailPage = DetailPage;
